import classNames from 'classnames';
import { IconProps } from '~/components/Icon/Icon';
import svg from './DefaultFace.svg';

export type FaceProps = IconProps;
export const DefaultFace = ({ className }: FaceProps) => (
  <img
    className={classNames('default-face', className)}
    width="144"
    height="144"
    src={svg}
    alt="citizen"
  />
);
